import React from 'react';

/**
 * UpsellBlock — CAP-008. Avviso in-body quando una feature è esclusa dal piano.
 *
 * Sostituisce il chip minuscolo di <FeatureGate> dove serve un messaggio chiaro
 * e leggibile nel corpo pagina (es. Foto & Video, PDF Completo del cantiere).
 *
 * È SOLO cosmesi: il confine di sicurezza resta il backend (403 via
 * HasFeature/@richiede_feature). Questo evita solo che l'artigiano resti davanti
 * a una funzione muta senza capire perché. La CTA porta a /impostazioni, dove
 * vivono i bottoni di upgrade (Smart/Business/Pro) — stesso pattern del pannello
 * upgrade di Documenti.
 *
 * Props:
 *   titolo    — riga in grassetto (opzionale)
 *   messaggio — testo dell'avviso (obbligatorio)
 *   cta       — etichetta del bottone (default "Scopri i piani")
 */
export default function UpsellBlock({ titolo, messaggio, cta = 'Scopri i piani' }) {
  return (
    <div
      role="note"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 14,
        flexWrap: 'wrap',
        padding: 16,
        marginBottom: 16,
        border: '1px solid var(--ds-border)',
        borderRadius: 'var(--radius-card)',
        background: 'var(--chip)',
      }}
    >
      <div style={{
        width: 40, height: 40, flexShrink: 0, borderRadius: '50%',
        background: 'rgba(46,160,132,0.12)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
             stroke="var(--brand)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
             aria-hidden="true">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
      </div>

      <div style={{ flex: '1 1 240px', minWidth: 0 }}>
        {titolo && (
          <div style={{ fontSize: 14, fontWeight: 500, color: 'var(--ink)', marginBottom: 2 }}>
            {titolo}
          </div>
        )}
        <div style={{ fontSize: 13, fontWeight: 400, color: 'var(--ds-muted)', lineHeight: 1.5 }}>
          {messaggio}
        </div>
      </div>

      <button
        onClick={function () { window.location.href = '/impostazioni'; }}
        style={{
          padding: '10px 20px', borderRadius: 'var(--radius-base)', border: 'none',
          background: 'var(--brand)', color: '#fff', cursor: 'pointer',
          fontSize: 13, fontWeight: 500, minHeight: 44, flexShrink: 0,
        }}
      >
        {cta}
      </button>
    </div>
  );
}
